module.exports = __webpack_public_path__ + "media/images/google-signin-85464cf04555e3212e389b354be4163ce1165af93e88bec1f187529561f3dc8c.png";